/**
 *Seed.js
 */
"use strict";

var Seed = {
    Path: "jscript/Seed/",
    Version: 6.2,
    SetPath: function (pPath) {
        this.Path = pPath + "/source/jscript/Seed/";
    }
};


define("Seed", (function (global) {
    return function () {
        var ret, fn;
        return ret || global.Seed;
    };
}(this)));

